module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"background color":"Hintergrundfarbe","text color":"Textfarbe","indicator color":"Rahmenfarbe","active color":"Aktivfarbe","active":"Aktiv","autoplay":"Autoplay","delay time (seconds)":"Verzögerung (Sekunden)","font (menu)":"Menü-Schriftart","add font long":"Fügen Sie eine Schriftart hinzu, indem Sie sie hier ablegen.","add font short":"Als Schriftart hinzufügen."}}')
  delete Component.options._Ctor
}
